export const approvalRoles = ["Super Admin", "Revenue Manager Approval"];
